module.exports = __webpack_public_path__ + "img/serviceNumber.516f6113.jpg";